import React from "react";

import './styles.scss';

import Ripple from "../../../../../../dumb/Ripple";
import MenuVertIcon from "../../../../../../icons/MenuVert";
import MerchantDropdown from "../../../../../../layouts/components/helpers/MerchantDropdown";

export default ({id, rowData, actions, update}) => {
  const actionsMap = ({name, onClick}) => (
    <Ripple className="table-actions__item" onClick={onClick}>
      {name}
    </Ripple>
  );

  return (
    <MerchantDropdown
      id={id}
      className="table-actions"
      itemsList={(actions(rowData, update) || []).map(actionsMap)}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      hideCaret
    >
      <div className="table-actions__icon">
        <MenuVertIcon width={4} />
      </div>
    </MerchantDropdown>
  )
}
